import { render, staticRenderFns } from "./RecipeRevisionHistory.vue?vue&type=template&id=7a6f5bcf&scoped=true&"
import script from "./RecipeRevisionHistory.vue?vue&type=script&lang=ts&"
export * from "./RecipeRevisionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeRevisionHistory.vue?vue&type=style&index=0&id=7a6f5bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f5bcf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
